import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 15,
  small: 14,
  xSmall: 9
};
const FavoriteIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6406 9.68848L15.001 10.334L14.3616 9.68848C12.7924 8.10384 10.2463 8.10384 8.67709 9.68848C7.15124 11.2294 7.10377 13.7186 8.56434 15.297L8.67074 15.4086L15.0011 21.8015L21.3085 15.4322L21.4152 15.3211C22.8956 13.7217 22.854 11.2324 21.3251 9.68848C19.756 8.10384 17.2098 8.10384 15.6406 9.68848ZM20.6146 10.3921C21.7667 11.5556 21.7981 13.4353 20.6876 14.6352L20.5925 14.7341L15.001 20.38L9.38766 14.7115L9.29297 14.6122C8.20195 13.433 8.2378 11.5533 9.38766 10.3921C10.5655 9.20263 12.4732 9.20263 13.651 10.3921L15.0011 11.7555L16.3512 10.3921C17.5291 9.20263 19.4367 9.20263 20.6146 10.3921Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteIcon.iconName = "FavoriteIcon";

export { FavoriteIcon };
